import { useEffect, useContext, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./Css/Card.css"; // Adjust the path as necessary
import { AppContext } from "../../context/AppContext";
import "./Css/CategoryWrapper.css";

import MetaTag from "./MetaTag";
import AdvertisementLeft from "./AdvertisementLeft";

const CategoryWrapper = () => {
  const { categoryName } = useParams();
  const [cardsData, setCardsData] = useState([]);
  const navigate = useNavigate();
  const {
    baseUrl,
    gameUrl,
    Backend_folder_path,
    addGameUrl,
    setCategory,
    gameList,
    setgamelist,
    setdescreption,
    setPageRefreshCount,
    metaTag,
    setgametitle,
    setmetadata,
    setgametype,
    setgameid,
    setappstorelink,
    AppStoreLink,
    gameIframe,
    setGameIframe,
    thumb_img,
    setThumbImgStatus,
    setGameIframeStatus,
  } = useContext(AppContext);
  const [meta, setMeta] = useState({
    title: "",
    keywords: "",
    descreption: "",
  });
  const { addThumbImg } = useContext(AppContext);

  useEffect(() => {
    const newCards = gameList.map((game, index) => ({
      title: `${game.game_title}`, // optional formatting
      id: index + 1,
      path: `${Backend_folder_path}${game.folder_path}/index.html`,
      thumb_img: `${Backend_folder_path}${game.thumbnail_img_path}`,
      url: game.url,
      category: game.category,
      descreption: game.description,
      enable: game.enable,
      title: game.game_title,
      meta_title: game.meta_title,
      meta_keyword: game.meta_keyword,
      meta_description: game.meta_description,
      gameType: game.gameType,
      gameId: game.id,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    }));
    setCardsData(newCards);

    //console.log("new",cardsData)
  }, [gameList]);
  const handleClick = (game) => {
    // navigate to the game layout with selected image
    setThumbImgStatus(true);
    setGameIframeStatus(false);
    const url = game.url;
    addGameUrl(game.path);
    addThumbImg(game.thumb_img);
    setCategory(game.category);
    setdescreption(game.descreption);
    setgametitle(game.title);
    setmetadata({
      title: game.meta_title,
      keywords: game.meta_keyword,
      descreption: game.meta_description,
    });
    setgametype(game.gameType);
    setgameid(game.gameId);
    setappstorelink({
      ...AppStoreLink,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    });
    const titleTag = document.querySelector("head > title");
    titleTag.textContent = game.title
      .replace(/-/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
    navigate(`/game/${url}`);
  };
  useEffect(() => {
    handleSubmit();
  }, [categoryName]);

  const handleSubmit = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/getgame-categorywise/${categoryName}`
      );
      // if (response) {
      //   setgamelist(response.data.data);

      //   //setCategory(response.data.data);
      // }
      const menucatdata = await axios.get(
        `${baseUrl}/getgame-bycategoryname/${categoryName}`
      );
      if (menucatdata) {
        //console.log("menucatdata",menucatdata.data.data.description);
        let catDes = menucatdata.data.data.description;
        setMeta({
          title: menucatdata.data.data.meta_title,
          keywords: menucatdata.data.data.meta_keyword,
          descreption: menucatdata.data.data.meta_description,
        });
        // console.log("met", menucatdata.data.data);
        const titleTag = document.querySelector("head > title");
        titleTag.textContent = menucatdata.data.data.meta_title;
        console.log("meta", menucatdata.data.data.meta_title);
        setdescreption(catDes);
      }
    } catch (error) {
      //console.error('Error saving category:', error);
    }
  };

  return (
    <>
      {/* <GameWrapper /> */}
      {meta.title && meta.keywords && (
        <MetaTag
          title={meta.title}
          keywords={meta.keywords}
          descreption={meta.descreption}
        />
      )}
      <div className="gallery-container">
        <h1 style={{ fontSize: "14px" }}>
          Free Online Games - <span>htmlgames4u.com</span>
        </h1>

        <div className="main-grid">
          <div className="left-ad">
            <AdvertisementLeft />
          </div>

          <div className="game-section">
            <div className="game-grid">
              {cardsData.map(
                (game) =>
                  game.enable && (
                    <div
                      style={{ cursor: "pointer" }}
                      className="game-card"
                      key={game.id}
                      onClick={() => {
                        handleClick(game);
                        setTimeout(() => {
                          window.scrollTo({ top: "59", behavior: "smooth" });
                        }, 100);
                      }}
                    >
                      <img src={game.thumb_img} alt={game.title} />
                      <div className="hover-title">{game.title}</div>
                    </div>
                  )
              )}
            </div>
          </div>

          <div className="right-ad">
            <AdvertisementLeft />
          </div>
        </div>
      </div>
    </>
  );
};

export default CategoryWrapper;
